import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { LoadingUI } from '@plugins/loading/loading';

import './dropzone.scss';

@Component
export default class Ddropzone extends Vue {
  @Prop() id;
  @Prop({ default: false }) loadingFlag;
  @Prop({ default: false }) info;

  dragoverFlag = false;

  onDragOver(event) {
    event.preventDefault();
    this.dragoverFlag = true;
  }

  onDragLeave() {
    this.dragoverFlag = false;
  }

  onDrop(event) {
    this.dragoverFlag = false;
    this.$emit('drop', event);
  }

  render(h) {
    return (
      <div class={`cmp-ddropzone ${this.dragoverFlag ? 'dragover' : 'nt'}`}
        onDragleave={this.onDragLeave}
        onDragover={this.onDragOver}
        onDrop={this.onDrop}
      >
        {this.loadingFlag ?
          <LoadingUI /> :
          this.info ?
            <div class="cmp-ddropzone--info">
              <div class="info-container">
                {this.info}
              </div>
            </div> :
            this.$slots.default
        }
      </div>
    );
  }
}
